module.exports = __webpack_public_path__ + "static/media/swords.b593bae3.svg";